import { render } from "./ZOROButton.vue?vue&type=template&id=a5802198&scoped=true"
import script from "./ZOROButton.vue?vue&type=script&lang=js"
export * from "./ZOROButton.vue?vue&type=script&lang=js"

import "./ZOROButton.vue?vue&type=style&index=0&id=a5802198&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/buildAgent/work/73b64d940d146bd6/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5802198"]])

export default __exports__